/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClientResponse, ApiClientResponseData } from '../types/api/ApiClientResponse';

export const serviceToUseQueryFn =
  <Fn extends (...args: any[]) => any, Rt = ReturnType<Fn>>(fn: Fn) =>
  (key: any, ...args: Parameters<Fn>): Rt => {
    return fn(...args);
  };

export const serviceToUseQueryFnData =
  <Fn extends (...args: any[]) => Promise<ApiClientResponse>>(fn: Fn) =>
  async (key: any, ...args: Parameters<typeof fn>): Promise<ApiClientResponseData<ServiceReturnType<Fn>>> => {
    const res = await fn(...args);
    return (res as ApiClientResponse<ServiceReturnType<Fn>>).data;
  };

type ServiceReturnType<T extends (...args: any) => any> = T extends (
  ...args: any
) => Promise<ApiClientResponse<infer U>>
  ? U
  : T extends (...args: any) => ApiClientResponse<infer U>
    ? U
    : any;
